import * as types from './constants';

// Get Billing Credits Balance
export const getBillingCreditsBalanceRequest = data => (
  { type: types.GET_BILLING_CREDITS_BALANCE_REQUEST, payload: data }
);

export const getBillingCreditsBalanceDone = data => (
  { type: types.GET_BILLING_CREDITS_BALANCE_DONE, payload: data }
);

export const getBillingCreditsBalanceFailed = errors => (
  { type: types.GET_BILLING_CREDITS_BALANCE_FAILED, payload: errors }
);